// agencies list
export const FETCHING_AGENCIES_LIST = '@@toyota/FETCHING_AGENCIES_LIST';
export const FETCHED_AGENCIES_LIST = '@@toyota/FETCHED_AGENCIES_LIST';
export const FETCHED_AGENCIES_LIST_FAILED = '@@toyota/FETCHED_AGENCIES_LIST_FAILED';
export const FETCHING_PROVINCES_LIST = '@@toyota/FETCHING_PROVINCES_LIST';
export const FETCHED_PROVINCES_LIST = '@@toyota/FETCHED_PROVINCES_LIST';
export const FETCHED_PROVINCES_LIST_FAILED = '@@toyota/FETCHED_PROVINCES_LIST_FAILED';
export const UPDATING_AGENCY_LIST = '@@toyota/UPDATING_AGENCY_LIST';
export const UPDATED_AGENCY_LIST = '@@toyota/UPDATED_AGENCY_LIST';
export const UPDATED_AGENCY_LIST_FAILED = '@@toyota/UPDATED_AGENCY_LIST_FAILED';
export const EXPORTING_TO_EXCEL_AGENCIES = '@@toyota/EXPORTING_TO_EXCEL_AGENCIES';
export const EXPORTED_TO_EXCEL_AGENCIES = '@@toyota/EXPORTED_TO_EXCEL_AGENCIES';
export const EXPORTED_TO_EXCEL_AGENCIES_FAILED = '@@toyota/EXPORTED_TO_EXCEL_AGENCIES_FAILED';
export const CLEAN_AGENCIES_EXPORT_URL = '@@toyota/CLEAN_AGENCIES_EXPORT_URL';
